export const STORE_USAGE_MONTH = "STORE_USAGE_MONTH";

export default (state = null, action) => {
    switch (action.type) {
        case STORE_USAGE_MONTH:
            return action.payload;
        default:
            return state;
    }
}
